module.exports = __webpack_public_path__ + "img/dark_top_bg.d0340702.png";